const __WEBPACK_NAMESPACE_OBJECT__ = devowlWp_realProductManagerWpClient;